import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface State {
  name: string | null
  mdn: string | null
  memberId: string | null
  isUnder14: boolean | null
  memberNo: number | null
}

interface Action {
  changeMemberInfo: (memberInfo: State) => void
}

export const memberStore = create<State & Action>()(
  devtools(
    persist(
      (set) => ({
        name: null,
        mdn: null,
        memberId: null,
        isUnder14: null,
        memberNo: null,
        changeMemberInfo: (memberInfo) => set(() => ({ ...memberInfo }), undefined, 'member/changeMemberInfo'),
      }),
      {
        name: 'member-store',
        storage: {
          getItem: (name) => {
            const value = sessionStorage.getItem(name)
            return value ? JSON.parse(value) : null
          },
          setItem: (name, value) => {
            sessionStorage.setItem(name, JSON.stringify(value))
          },
          removeItem: (name) => {
            sessionStorage.removeItem(name)
          },
        },
      },
    ),
    { name: 'memberStore' },
  ),
)
